import { QuerySwitch } from 'components/QuerySwitch';
import {
  LocationRecordDetailDataContext,
  LocationRecordDetailDataProvider,
} from 'pages/LocationSettingsPage/LocationRecordDetail.data.context';
import { PositionsAllocationSettingsPageForm } from 'pages/LocationSettingsPage/PositionsAllocation/PositionsAllocationSettingsPageForm';
import { FC } from 'react';

export const PositionsAllocationSettingsPage: FC = () => {
  return (
    <LocationRecordDetailDataProvider>
      <QuerySwitch
        context={LocationRecordDetailDataContext}
        component={PositionsAllocationSettingsPageForm}
      />
    </LocationRecordDetailDataProvider>
  );
};
